module.exports = __webpack_public_path__ + "static/img/Mascotas.b1d7d5ad.png";